<!-- Spinner -->

<!-- Content -->
@if ({selectedNodes: (slideViewerFacade.currentSelectedSlideNodesFiltered$ | async) | sortBy_shared:'asc':'position', selectedSlideNodes: (slideViewerFacade.currentSelectedSlideNodes$ | async), selectedNodeIndex: (slideViewerFacade.currentSelectedSlideIndex$ | async)}; as slideData) {
  <div class="mdsf-slide-control">
    @if (slideData.selectedNodes.length > 0) {
      <!-- Position -->
      <span class="position">
        <input class="mdsf-slide-control_input"
          type="number"
          min="1"
          [max]="slideData.selectedNodes.length"
          [value]="slideData.selectedNodeIndex + 1"
          (change)="slideViewerFacade.requestGoToSlideByIndex($event.target, slideData.selectedNodeIndex, slideData.selectedNodes, slideData.selectedSlideNodes, route.snapshot.queryParams)">
        / {{ slideData.selectedNodes.length }}
      </span>
      <!-- Progress Bar -->
      <div class="mdsf-progress">
        @for (node of slideData.selectedNodes; track node; let i = $index) {
          @if ((slideViewerFacade.page$(node.page) | async); as page) {
            <div
              class="mdsf-progress-point available"
              [class.current]="slideData.selectedNodeIndex === i"
              [class.past]="slideData.selectedNodeIndex > i"
              [routerLink]="(slideViewerFacade.slideUrlByNode$(node) | async)"
              [queryParams]="route.snapshot.queryParams"
              placement="top"
              [ngbTooltip]="(i + 1) + ': ' + page.title">
              <div class="mdsf-progress-point-marker"></div>
            </div>
          }
        }
        <div class="mdsf-progress-wrap">
          <div class="mdsf-progress-bar"
            [class.transition-easeout]="true"
            [style.transform]="'scaleX(' + (slideViewerFacade.currentSelectedSlidePercentage$ | async) + ')'">
          </div>
        </div>
      </div>
      <!-- Previous -->
      @if ((slideViewerFacade.previousSlideUrl$ | async); as previousUrl) {
        <div class="button mdsf-btn"
          [routerLink]="['/' + previousUrl]"
          [queryParams]="route.snapshot.queryParams">
          <span class="fa fa-chevron-left"></span>
        </div>
      }
      <!-- Next -->
      @if ((slideViewerFacade.nextSlideUrl$ | async); as nextUrl) {
        <div class="button mdsf-btn"
          [routerLink]="['/' + nextUrl]"
          [queryParams]="route.snapshot.queryParams">
          <span class="fa fa-chevron-right"></span>
        </div>
      }
    }
  </div>
  <div class="mdsf-slide-button-group d-none d-md-inline-block">
    <div class="button mdsf-btn" (click)="feedbackControlService.openFeedbackModal()">
      <a>FEEDBACK</a>
    </div>
  </div>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}

